import {StyleRepository} from '@domain/model/Style/StyleRepository';

export const DeleteCustomerId = async (repository: StyleRepository): Promise<void> =>
  await repository.deleteCustomerId();
